// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DropboxOutlinedSvg from "@ant-design/icons-svg/es/asn/DropboxOutlined";
import AntdIcon from '../components/AntdIcon';

var DropboxOutlined = function DropboxOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DropboxOutlinedSvg
  }));
};

DropboxOutlined.displayName = 'DropboxOutlined';
export default React.forwardRef(DropboxOutlined);